import { useEffect, useState } from 'react'
import './App.css'
import { Link, Outlet, useMatchRoute, useNavigate, useRouterState, useSearch } from '@tanstack/react-router'
import { AppShell, Text, Burger, Group, UnstyledButton, Box } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks';
import { NavigationButton } from './Components/NavigationButton';
import { IconHome, IconMessageCircle, IconSettings } from '@tabler/icons-react';
import { useAuthStore } from './Stores/AuthStore';
import { getApiAuthState } from './API';
import { AxiosError } from 'axios';

function AdminNavigation(props: { onClickLink?: () => void }) {
  return <>
    <NavigationButton match={{ to: "/admin/config", fuzzy: true }} onClickLink={props.onClickLink}><IconSettings style={{ marginRight: "10px" }} />設定</NavigationButton>
  </>
}

function Navigation(props: { onClickLink?: () => void }) {
  const auth = useAuthStore()
  const search = useSearch({ strict: false })
  return <Group flex={1} justify='end' >
    {/* <NavigationButton match={{ to: "/" }}><IconHome style={{ marginRight: "10px" }} />首頁</NavigationButton>
    <NavigationButton match={{ to: "/chat" }}><IconMessageCircle style={{ marginRight: "10px" }} />聊天</NavigationButton> */}
    {auth.data.role == "admin" && <AdminNavigation onClickLink={props.onClickLink} />}
  </Group>
}

function App() {
  const auth = useAuthStore()
  const router = useRouterState();
  const matchRoute = useMatchRoute()
  const navigate = useNavigate()

  const [opened, { toggle }] = useDisclosure();

  useEffect(() => {
    auth.SetUpdating(true)
    try {
      getApiAuthState().then(result => {
        if (result.data.userName && result.data.role)
          auth.Update(result.data)
      }).catch((e: AxiosError) => {
        var index = matchRoute({ to: "/" })
        var adminLogin = matchRoute({ to: "/admin/login" })
        if (e.status == 401 && !index && !adminLogin) {
          navigate({ to: "/", search: { redirect: router.location.pathname } })
        }
      })
    } catch (e) {

    }
    auth.SetUpdating(false)
  }, [])

  const isHomePage = matchRoute({ to: "/" });

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{ width: 300, breakpoint: 'sm', collapsed: { desktop: true, mobile: !opened } }}
      padding="md"
    >
      {!isHomePage && <AppShell.Header>
        <Group h="100%" px="md">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <Group className='no-underline' justify="space-between" h="100%" style={{ flex: 1 }}>
            <Group gap={10}>
              {/* <Image src={logo} w={25} /> */}
              <Link to='/'>
                <Text c="#4a4a4a">
                  AI ChatBot
                </Text>
              </Link >
            </Group>
            <Group ml="sm" gap={0} h="100%" flex={1}>
              {/* <Link to='/'>
                  <Image h={30} fit="contain" src={Logo} />
                </Link> */}
              <Navigation />
            </Group>
          </Group>
        </Group>
      </AppShell.Header>}

      <AppShell.Navbar py="md" px={4}>
        <Navigation />
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  )
}

export default App
